import { gql } from '@apollo/client';


export const ADD_ITEM_TO_CART = gql`
    mutation cartItem($period: String!, $delivery_id: ID, $dish_id: ID!, $portions: Int!, $source_name: String) {
        cartItem(
            period: $period,
            delivery_id: $delivery_id,
            dish_id: $dish_id,
            portions: $portions,
            source_name: $source_name,
        ) {
            success
        }
    }
`;

export const ADD_ITEMS_TO_CART_BY_DELIVERY_ID = gql`
    mutation addItemsToCartByDeliveryId($period: String!, $deliveryId: ID!) {
        addItemsToCartByDeliveryId(
            period: $period,
            deliveryId: $deliveryId,
        ) {
            success
        }
    }
`;

export const ADD_ITEMS_TO_CART_BY_ID_LIST = gql`
    mutation addItemsToCartByIdList(
        $period: String!,
        $trialScenario: trialScenario,
        $dishes: [ID]!
    ) {
        addItemsToCartByIdList(
            period: $period,
            trial_scenario: $trialScenario,
            dishes: $dishes,
        ) {
            success
            cart {
                period
                type
                isSubscriptionActivated
                id
                haveDishesFromTrial
                typeOfSet
                sections {
                    id
                    title
                    gift_category
                    cartType
                    items {
                        dish_id
                        has_crossed_out_price
                        type
                        portions
                        price
                        discount_price
                        promoDiscountPrice
                        is_promo
                        dish {
                            id
        title
        titleEn
        caption
        captionEn
        cooking_time
        cook_until
        composition
        weight
        price
        portions
        previewImage
        previewMobileImage
        verticalImage
        umAlias
        categoryId: category_id
        partnersComment
        parentId
        # BR-1104
        secondDishPart
        replaceableIngredient
        nutrition {
            carbohydrate {
                title
                value
                unit
            }
            fat {
                title
                value
                unit
            }
            protein {
                title
                value
                unit
            }
            calories {
                title
                value
                unit
            }
        }
        metaLabel @client
        tags {
            id
            erp_id
            title
            category_id
            category_name
        }
                        }
                    }
                }
                totals {
                    # Легаси поля, от которых нужно отказаться
        total_price
        total_discount_price
        total_common_price
        delivery_price
        promocode_applied
        promocode_amount
        discount_amount
        static_discount_price
        static_common_price
        referral_amount
        # FRNT-2607
        # Новые поля, на которые нужно перейти и отказаться от использования полей выше
        dishesPrice
        deliveryPrice
        subscriptionDiscountAmount
        promocodeDiscountAmount
        specialDiscountAmount
        subscriptionPrice
        onlinePrice
        cashPrice
        cashbackReward
        cashback_amount
        referral_amount
        applied_discount_amount
                }
                discount_conditions {
                     promocode
        promocode_status
        isCertificate
        isPromoCodeActivated
        promoCodeApplyingErrorMessage
        isPromocodeCombineWithDiscount
        isPromocodeCombineWithAccount
        differenceBetweenPromocodeAndOrder
        promoCodeApplyingErrorMessage
        isPromoCodeExists
        isSubscriptionActivated
        deliveriesCount
        discountType
        discountValue
        discountDuration
                }
            }
        }
    }
`;

export const ADD_ITEMS_TO_CART_BY_SCHEMA = gql`
    mutation addItemsToCartBySchema(
        $period: String!,
        $menuType: menuType,
        $tags: [ID],
        $schema: [schemaItem!]!,
        $trial_scenario: trialScenario,
    ) {
        addItemsToCartBySchema(
            period: $period,
            menuType: $menuType,
            tags: $tags,
            schema: $schema,
            trial_scenario: $trial_scenario,
        ) {
            success
            cart {
                period
                isSubscriptionActivated
                id
                typeOfSet
                isSectionsEmpty @client
                haveDishesFromTrial
                type
                sections {
                    id
                    title
                    gift_category
                    cartType
                    items {
                        ...ROOT_CART_DISH_ITEM
                        dish {
                            ...ROOT_MENU_DISH_ITEM
                        }
                    }
                }
                totals {
                    ...ROOT_CART_TOTAL
                }
                discount_conditions {
                    ...ROOT_CART_DISCOUNT_CONDITIONS
                }
            }
        }
    }
`;

export const ADD_ITEMS_TO_CART_BY_PERIOD = gql`
    mutation addItemsToCartByPeriod(
        $period: String!,
        $fillByPeriod: String!,
        $tags: [ID],
        $source_name: String,
    ) {
        addItemsToCartByPeriod(
            period: $period,
            fillByPeriod: $fillByPeriod,
            tags: $tags,
            source_name: $source_name,
        ) {
            success
            cart {
                period
                type
                isSubscriptionActivated
                id
                haveDishesFromTrial
                typeOfSet
                sections {
                    id
                    title
                    gift_category
                    cartType
                    items {
                        ...ROOT_CART_DISH_ITEM
                        dish {
                            ...ROOT_MENU_DISH_ITEM
                        }
                    }
                }
                totals {
                    ...ROOT_CART_TOTAL
                }
                discount_conditions {
                    ...ROOT_CART_DISCOUNT_CONDITIONS
                }
            }
        }
    }
`;
